import { PRODUCTS_NAMES, TYPES_PLANS } from "#/constants";

export const CONTACT_PAGE_DESCRIPTION = {
  [TYPES_PLANS.DENTAL]: `Confira os telefones para realizar consutas, alterações e cancelamento do seu Plano ${
    PRODUCTS_NAMES[TYPES_PLANS.DENTAL]
  }.`,
  [TYPES_PLANS.TELEMEDICINE]: `Confira os telefones para realizar atendimento e agendamento de consulta com seu Plano ${
    PRODUCTS_NAMES[TYPES_PLANS.TELEMEDICINE]
  }.`,
};
